import { createAsyncThunk, createSlice, isAnyOf } from "@reduxjs/toolkit";
import { API_ENDPOINTS, METHOD_TYPE } from "../../utils/apiUrls";
import api from "../../utils/api";

const initialState = {
    isLoading: false,
    error: null,
    corporateScreeningList: { rows: [], count: 0, totalPages: 0, currentPage: 1, type: 200 },
    corporateDetails : {},
    linkedIndividuals: { rows: [], summary: {} },
    globalSearches: { rows: [], count: 0, totalPages: 0, currentPage: 1, type: 200 },
    globalSearchDetail: null,
    fetchDocuments: { rows: [], count: 0, totalPages: 0, currentPage: 1, type: 200 },
    adverseMedias:[],
    amlComments:{ rows: [], count: 0, totalPages: 0, currentPage: 1, type: 200 },
    screeningComments: { rows: [], count: 0, totalPages: 0, currentPage: 1, type: 200 },
    fieldHistory: { rows: [], count: 0, totalPages: 0, currentPage: 1, type: 200 },
    corporateRequestedDocument: { rows: [], count: 0, totalPages: 0, currentPage: 1, type: 200 },
    oldData: [],
    searchCertificateDetails: null,
    pendingCorporateScreeningCount : 0
}

export const fetchCorporateScreeningList = createAsyncThunk("corporate_screening/getCorporateScreeninglist", async (queryParam) => {
    try {
        let data = {
            method: METHOD_TYPE.get,
            url: API_ENDPOINTS.getCorporateScreeninglist + queryParam
        };
        const response = await api(data);
        return response.data;

    } catch (error) {
        throw error?.response?.data;
    }
});

export const manageContinuousMonitoring = createAsyncThunk("corporate_screening/manageContinuousMonitoring", async ({queryParams, payload}) => {
    try {
        let data = {
            method: METHOD_TYPE.post,
            url: API_ENDPOINTS.manageCorporateContinuousMonitoring + queryParams,
            data: payload
        };
        const response = await api(data);
        return response.data;
    } catch (error) {
        throw error?.response?.data;
    }
});

export const fetchCorporateClientPersonalDetail = createAsyncThunk("corporate_screening/fetchCorporateClientPersonalDetail", async (requestData) => {
    try {
      const data = {
        method: METHOD_TYPE.get,
        url: `${API_ENDPOINTS.fetchCorporateClientPersonalDetail}${requestData.queryParam}`,
        headers: {}
      };
      if(requestData?.webformToken){
        data['headers']['publictoken'] = requestData?.webformToken
      }
      const response = await api(data);
      return response.data;
    } catch (error) {
  
      throw error?.response?.data;
    }
  });

export const getCorporateLinkedIndividuals = createAsyncThunk("corporate_screening/getCorporateLinkedIndividuals", async (queryParam) => {
    try {
        const response = await api({
            method: METHOD_TYPE.get,
            url: API_ENDPOINTS.getCorporateLinkedIndividuals + queryParam
        });
        return response.data;
    } catch (error) {
        throw error?.response?.data;
    }
});
  export const manageCorporateClientStatus = createAsyncThunk("corporate_screening/manageCorporateClientStatus", async ({queryParam,requestData}) => {
    try {
        let data = {
            method: METHOD_TYPE.post,
            url: API_ENDPOINTS.manageCorporateClientStatus + queryParam,
            data: requestData,
        };
        const response = await api(data);
        return response.data.data;

    } catch (error) {
        throw error?.response?.data;
    }
});

export const downloadCorporateClientDocZipFiles = createAsyncThunk("downloadCorporateClientDocZipFiles", async (queryParam) => {
    try {
        let data = {
            method: METHOD_TYPE.get,
            url: API_ENDPOINTS.downloadCorporateClientDocZipFiles + queryParam,
            responseType: 'blob',
        };
        const response = await api(data);
        return response.data;
    } catch (error) {
        // Handle error here
        if (error.response && error.response.data instanceof Blob) {
            const errorText = await error.response.data.text();
            try {
                const errorJson = JSON.parse(errorText);                
                throw errorJson || 'Something Went Wrong';
            } catch (parseError) {
                throw parseError || 'Something Went Wrong';
            }
        } else {
            throw 'Something Went Wrong';
        }
    }
});

export const updateCorporateDetailsWithReason = createAsyncThunk("corporate_screening/updateCorporateDetailsWithReason", async ({ payload, queryParam }) => {
    try {
        let data = {
            method: METHOD_TYPE.post,
            url: API_ENDPOINTS.updateCorporateDetailsWithReason + queryParam,
            data: payload
        };
        const response = await api(data);
        return response.data;

    } catch (error) {
        throw error?.response?.data;
    }
});

export const getAllGlobalSearchById = createAsyncThunk("corporate_screening/getAllGlobalSearchById", async (queryParams) => {
    try {
        let data = {
            method: METHOD_TYPE.get,
            url: API_ENDPOINTS.getAllGlobalSearchById + queryParams
        };
        const response = await api(data);
        return response.data;
    } catch (error) {
        throw error?.response?.data;
    }
});

export const saveRelevantResult = createAsyncThunk("corporate_screening/saveRelevantResult", async ({payload}) => {
    try {
        let data = {
            method: METHOD_TYPE.post,
            url: API_ENDPOINTS.saveCorporateRelevantResult,
            data: payload
        };
        const response = await api(data);
        return response.data;
    } catch (error) {
        throw error?.response?.data;
    }
});

export const removeRelevantResult = createAsyncThunk("corporate_screening/removeRelevantResult", async ({payload}) => {
    try {
        let data = {
            method: METHOD_TYPE.post,
            url: API_ENDPOINTS.removeCorporateRelevantResult,
            data: payload
        };
        const response = await api(data);
        return response.data;
    } catch (error) {
        throw error?.response?.data;
    }
});

export const getGlobalSearchById = createAsyncThunk("corporate_screening/getGlobalSearchById", async (queryParams) => {
    try {
        let data = {
            method: METHOD_TYPE.get,
            url: API_ENDPOINTS.getCorporateGlobalSearchById + queryParams
        };
        const response = await api(data);
        return response.data;
    } catch (error) {
        throw error?.response?.data;
    }
});

export const fetchRequestedUploadedDocuments = createAsyncThunk("corporate_screening/fetchRequestedUploadedDocuments", async (queryParam) => {
    try {
        let data = {
            method: METHOD_TYPE.get,
            url: API_ENDPOINTS.fetchRequestedUploadedDocuments + queryParam
        };
        const response = await api(data);
        return response.data;
    } catch (error) {
        throw error?.response?.data;
    }
});

export const requestDocument = createAsyncThunk("corporate_screening/requestDocument", async (queryParams) => {
    try {
        let data = {
            method: METHOD_TYPE.get,
            url: API_ENDPOINTS.corporateRequestDocument + queryParams
        };
        const response = await api(data);
        return response.data;
    } catch (error) {
        throw error?.response?.data;
    }
});

export const uploadDocument = createAsyncThunk("corporate_screening/uploadDocument", async (payload) => {
    try {
        let data = {
            method: METHOD_TYPE.post,
            url: API_ENDPOINTS.corporateUploadDocument,
            data: payload
        };
        const response = await api(data);
        return response.data;
    } catch (error) {
        throw error?.response?.data;
    }
});

export const updateScreeningInfo = createAsyncThunk("corporate_screening/updateScreeningInfo", async ({ payload, queryParam }) => {
    try {
        let data = {
            method: METHOD_TYPE.post,
            url: API_ENDPOINTS.corporateUpdateScreeningInfo + queryParam,
            data: payload
        };
        const response = await api(data);
        return response.data;
    } catch (error) {
        throw error?.response?.data;
    }
});

export const resendToCheckerMaker = createAsyncThunk("corporate_screening/resendToCheckerMaker", async ({payload, queryParam}) => {
    try {
        let data = {
            method: METHOD_TYPE.post,
            url: API_ENDPOINTS.corporateResendToCheckerMaker + queryParam,
            data: payload
        };
        const response = await api(data);
        return response.data;
    } catch (error) {
        throw error?.response?.data;
    }
});

export const sendToCheckerMlro = createAsyncThunk("corporate_screening/sendToCheckerMlro", async ({payload, queryParam}) => {
    try {
        let data = {
            method: METHOD_TYPE.post,
            url: API_ENDPOINTS.corporateSendToCheckerMlro + queryParam,
            data: payload
        };
        const response = await api(data);
        return response.data;
    } catch (error) {
        throw error?.response?.data;
    }
});

export const manageScreeningAction = createAsyncThunk("corporate_screening/manageScreeningAction", async ({queryParams, payload}) => {
    try {
        let data = {
            method: METHOD_TYPE.post,
            url: API_ENDPOINTS.corporateManageScreeningAction + queryParams,
            data: payload
        };
        const response = await api(data);
        return response.data;
    } catch (error) {
        throw error?.response?.data;
    }
})
export const getCorporateFieldHistory = createAsyncThunk("corporate_screening/getCorporateFieldHistory", async (queryParam) => {
    try {
        let data = {
            method: METHOD_TYPE.get,
            url: API_ENDPOINTS.getCorporateFieldHistory + queryParam
        };
        const response = await api(data);
        return response.data;

    } catch (error) {
        throw error?.response?.data;
    }
});
export const getCorporateScreeningComments = createAsyncThunk("corporate_screening/getCorporateScreeningComments", async (queryParam) => {
    try {
        let data = {
            method: METHOD_TYPE.get,
            url: API_ENDPOINTS.getCorporateScreeningComments + queryParam
        };
        const response = await api(data);
        return response.data;

    } catch (error) {
        throw error?.response?.data;
    }
});

export const getAdverseMedia = createAsyncThunk("corporate_screening/getAdverseMedia", async (queryParams) => {
    try {
        let data = {
            method: METHOD_TYPE.get,
            url: API_ENDPOINTS.getAdverseMedia + queryParams
        };
        const response = await api(data);
        return response.data;
    } catch (error) {
        throw error?.response?.data;
    }
});

export const uploadMediaImage = createAsyncThunk("corporate_screening/uploadMediaImage", async ({queryParams,payload}) => {
    try {
        let data = {
            method: METHOD_TYPE.post,
            url: API_ENDPOINTS.uploadMediaImage + queryParams,
            data: payload
        };
        const response = await api(data);
        return response.data;
    } catch (error) {
        throw error?.response?.data;
    }
})

export const saveAmlInfoComment = createAsyncThunk("corporate_screening/saveAmlInfoComment", async ( payload) => {
    try {
        let data = {
            method: METHOD_TYPE.post,
            url: API_ENDPOINTS.saveAmlInfoComment ,
            data: payload
        };
        const response = await api(data);
        return response.data;
    } catch (error) {
        throw error?.response?.data;
    }
})

export const saveAdverseMediaComment = createAsyncThunk("corporate_screening/saveAdverseMediaComment", async ( payload) => {
    try {
        let data = {
            method: METHOD_TYPE.post,
            url: API_ENDPOINTS.saveAdverseMediaComment ,
            data: payload
        };
        const response = await api(data);
        return response.data;
    } catch (error) {
        throw error?.response?.data;
    }
})

export const fetchAmlComments = createAsyncThunk("corporate_screening/fetchAmlComments", async (queryParam) => {
    try {
        let data = {
            method: METHOD_TYPE.get,
            url: API_ENDPOINTS.fetchAmlComments + queryParam,
        };
        const response = await api(data);
        return response.data;
    } catch (error) {
        throw error?.response?.data;
    }
})
export const fetchCorporateRequestedDocuments = createAsyncThunk("individual_screening/fetchCorporateRequestedDocuments", async (queryParam) => {
    try {
        let data = {
            method: METHOD_TYPE.get,
            url: API_ENDPOINTS.fetchCorporateRequestedDocuments + queryParam,
        };
        const response = await api(data);
        return response.data;
    } catch (error) {
        throw error?.response?.data;
    }
})

export const getCorporateScreeningClientHistory = createAsyncThunk("corporate_screening/getCorporateScreeningClientHistory", async (queryParams) => {
    try {
        let data = {
            method: METHOD_TYPE.get,
            url: API_ENDPOINTS.getCorporateScreeningClientHistory + queryParams
        };
        const response = await api(data);
        return response.data;
    } catch (error) {
        throw error?.response?.data;
    }
});

export const fetchPendingCorporateScreeningCount = createAsyncThunk("corporate_screening/fetchPendingCorporateScreeningCount", async (queryParams) => {
    try {
        let data = {
            method: METHOD_TYPE.get,
            url: API_ENDPOINTS.fetchPendingCorporateScreeningCount + queryParams
        };
        const response = await api(data);
        return response.data;
    } catch (error) {
        throw error?.response?.data;
    }
});

export const getCorporateSearchCertificate = createAsyncThunk("corporate_screening/getCorporateSearchCertificate", async ({ queryParams, payload }) => {
    try {
        let data = {
            method: METHOD_TYPE.post,
            url: API_ENDPOINTS.getCorporateSearchCertificate + queryParams,
            data: payload
            // responseType: 'arraybuffer'
        };
        const response = await api(data);
        return response.data;
    } catch (error) {
        throw error?.response?.data;
    }
});

const fetchCorporateScreeningSlice = createSlice({
    name: "corporateScreening",
    initialState,
    reducers: {
        resetCorporateScreeningList(state, action) {
            state.corporateScreeningList = { rows: [], count: 0, totalPages: 0, currentPage: 1, type: 200 };
        },
        resetGlobalSearchDetails(state, action) {
            state.globalSearchDetail = null;
        },
        updateCorporateScreeningList(state, action) {
            state.corporateScreeningList = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCorporateScreeningList.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.error = null;
                state.corporateScreeningList = payload.data;
            })
            .addCase(fetchCorporateClientPersonalDetail.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.error = null;
                state.corporateDetails = payload.data;
              })
            .addCase(getCorporateLinkedIndividuals.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.error = null;
                state.linkedIndividuals = payload.data || { rows: [], summary: {} };
            })
            .addCase(manageContinuousMonitoring.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.error = null;
            })
            .addCase(manageCorporateClientStatus.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.error = null;
            })
            .addCase(downloadCorporateClientDocZipFiles.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.error = null;
            })
            .addCase(updateCorporateDetailsWithReason.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.error = null;
            })
            .addCase(getAllGlobalSearchById.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.error = null;
                state.globalSearches = payload.data;
            })
            .addCase(saveRelevantResult.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.error = null;
            })
            .addCase(removeRelevantResult.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.error = null;
            })
            .addCase(getGlobalSearchById.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.error = null;
                state.globalSearchDetail = payload.data;
            })
            .addCase(fetchRequestedUploadedDocuments.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.error = null;
                state.fetchDocuments = payload.data
            })
            .addCase(requestDocument.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.error = null;
            })
            .addCase(uploadDocument.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.error = null;
            })
            .addCase(updateScreeningInfo.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.error = null;
            })
            .addCase(resendToCheckerMaker.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.error = null;
            })
            .addCase(sendToCheckerMlro.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.error = null;
            })
            .addCase(manageScreeningAction.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.error = null;
            })
            .addCase(getAdverseMedia.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.adverseMedias = payload.data;
                state.error = null;
            })
            .addCase(getCorporateFieldHistory.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.error = null;
                state.fieldHistory = payload.data;
            })
            .addCase(getCorporateScreeningComments.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.error = null;
                state.screeningComments = payload.data;
            })
            .addCase(uploadMediaImage.fulfilled, (state, {payload})=>{
                state.isLoading = false;
                state.error = null;
            })
            .addCase(saveAmlInfoComment.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.error = null;
            })
            .addCase(saveAdverseMediaComment.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.error = null;
            })
            .addCase(fetchAmlComments.fulfilled, (state, {payload})=>{
                state.isLoading = false;
                state.error = null;
                state.amlComments=payload.data
            })
            .addCase(getCorporateScreeningClientHistory.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.error = null;
                state.oldData = payload.data;
            })
            .addCase(fetchCorporateRequestedDocuments.fulfilled, (state, {payload})=>{
                state.isLoading = false;
                state.error = null;
                state.corporateRequestedDocument=payload.data
            })
            .addCase(fetchPendingCorporateScreeningCount.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.error = null;
                state.pendingCorporateScreeningCount = payload.data
            })
            .addCase(getCorporateSearchCertificate.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.searchCertificateDetails = payload.data;
                state.error = null;
            })
            .addMatcher(isAnyOf(fetchCorporateScreeningList.pending, manageContinuousMonitoring.pending, fetchCorporateClientPersonalDetail.pending, getCorporateLinkedIndividuals.pending, downloadCorporateClientDocZipFiles.pending,manageCorporateClientStatus.pending,updateCorporateDetailsWithReason.pending, getAllGlobalSearchById.pending,saveRelevantResult.pending, removeRelevantResult.pending, getGlobalSearchById.pending, fetchRequestedUploadedDocuments.pending, requestDocument.pending, uploadDocument.pending, updateScreeningInfo.pending, resendToCheckerMaker.pending, sendToCheckerMlro.pending, manageScreeningAction.pending, getAdverseMedia.pending, uploadMediaImage.pending, saveAmlInfoComment.pending, saveAdverseMediaComment.pending, fetchAmlComments.pending,getCorporateFieldHistory.pending,getCorporateScreeningComments.pending, getCorporateScreeningClientHistory.pending,fetchCorporateRequestedDocuments.pending, fetchPendingCorporateScreeningCount.pending, getCorporateSearchCertificate.pending), (state) => {
                state.isLoading = true;
            })
            .addMatcher(isAnyOf(fetchCorporateScreeningList.rejected, manageContinuousMonitoring.rejected, fetchCorporateClientPersonalDetail.rejected, getCorporateLinkedIndividuals.rejected, downloadCorporateClientDocZipFiles.rejected,manageCorporateClientStatus.rejected,updateCorporateDetailsWithReason.rejected, getAllGlobalSearchById.rejected, saveRelevantResult.rejected, removeRelevantResult.rejected, getGlobalSearchById.rejected, fetchRequestedUploadedDocuments.rejected, requestDocument.rejected, uploadDocument.rejected, updateScreeningInfo.rejected, resendToCheckerMaker.rejected, sendToCheckerMlro.rejected , manageScreeningAction.rejected, getAdverseMedia.rejected, uploadMediaImage.rejected, saveAmlInfoComment.rejected, saveAdverseMediaComment.rejected, fetchAmlComments.rejected,getCorporateFieldHistory.rejected,getCorporateScreeningComments.rejected, getCorporateScreeningClientHistory.rejected,fetchCorporateRequestedDocuments.rejected, fetchPendingCorporateScreeningCount.rejected, getCorporateSearchCertificate.rejected), (state, { error }) => {
                state.isLoading = false;
                state.error = (error) ? error.message : "Request Failed Please Try Again ";
            })
    }
});

const { resetCorporateScreeningList, resetGlobalSearchDetails, updateCorporateScreeningList  } = fetchCorporateScreeningSlice.actions;
const corporateScreeningReducer = fetchCorporateScreeningSlice.reducer;

export { resetCorporateScreeningList, resetGlobalSearchDetails, updateCorporateScreeningList, corporateScreeningReducer };
export default corporateScreeningReducer;
